module.exports = __webpack_public_path__ + "img/exclamation.97784325.svg";